import angular, { ILogService, ITimeoutService } from 'angular'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { TiposDocEstadosStore } from 'src/_candidato/data/tiposStore'
import { IModelAccion, IModelCurriculum, IReporteCV } from 'src/model/candidato-api'

import './panel-cv-view.scss'

class PanelCvViewComponentCtrl {
  cv!: { cv: IModelCurriculum }

  report: IReporteCV
  $loading = false

  datosTipos: TiposDocEstadosStore

  history = {
    list: [] as IModelAccion[],
    show: true,
  }

  docs = {
    show: true,
  }

  constructor(
    private $element: JQLite,
    private $log: ILogService,
    private $timeout: ITimeoutService,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    this.$log.info('[PanelCvViewComponentCtrl] onInit')

    this._leerCV().then(() => {
      this.AccesoDatos.Datos_Client.tiposParaDocuemntos().then((responseTipos) => {
        this.datosTipos = new TiposDocEstadosStore(responseTipos)

        this.$loading = false
      })
    })
  }

  $postLink() {
    $('body').css('overflow', 'auto')
  }

  private _leerCV() {
    this.$loading = true

    return this.AccesoDatos.GestionCurr_CLIENT.leerCv(this.cv.cv.form_id, this.cv.cv.idcv).then((reportResponse) => {
      this.report = reportResponse
      this.history.list = reportResponse.history.list

      this.$loading = false
    })
  }

  _refreshcv() {
    this.report = null

    this._leerCV()
  }

  toggleHistory() {
    this.history.show = !this.history.show
  }

  toggleDocs() {
    this.docs.show = !this.docs.show
  }
}

angular.module('candidato').component('panelCvView', {
  bindings: {
    cv: '<',
  },
  controller: PanelCvViewComponentCtrl,
  // templateUrl: "panel-cv-view.component.html",
  template: require('./panel-cv-view.component.html'),
})
